import { headType } from "./head-type.enum";

export enum headUnitEndsWith {
    core = 'core',
    units = 'units',
    special = 'special',
}

export enum headUnitInclusions {
    staircase = 'staircase',
    elevator = 'elevator',
}

export enum preference {
    yes = 'yes',
    no = 'no',
    optional = 'optional'
}

export interface HeadType {
    type: headType,
    bays: number,
    orientationConfig?: {
        shift: number,
        corridorCenterDistance: number,
        corridorWidth: number
    },
    width?: number,
    length?: number,
    endsWith?: headUnitEndsWith,
    includes: headUnitInclusions[],
    preferred?: preference,
    highrise?: boolean, // > 20m.
}

export const defaultHead = headType.none;

export const getHeadTypesModel: () => HeadType[] = () => [
    {
        type: headType.none,
        bays: 0,
        width: 0,
        length: 0,
        orientationConfig: {
            shift: 0,
            corridorCenterDistance: 0,
            corridorWidth: 0,
        },
        highrise: true,
        includes: [],
        uiName: '',
    },
    {
        type: headType._2C_XL,
        bays: 6,
        width: 11.9,
        length: 20.4,
        orientationConfig: {
            shift: 0,
            corridorCenterDistance: 10.2,
            corridorWidth: 1.5,
        },
        endsWith: headUnitEndsWith.units,
        includes: [],
        preferred: preference.yes,
        highrise: false,
    },
    {
        type: headType._2C_S1S2,
        bays: 6,
        width: 11.9,
        length: 20.4,
        orientationConfig: {
            shift: 0,
            corridorCenterDistance: 10.2,
            corridorWidth: 1.5,
        },
        endsWith: headUnitEndsWith.units,
        includes: [],
        preferred: preference.yes,
        highrise: false,
    },
]
